import React, { useState, useContext, useMemo, useEffect, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { RouteComponentProps, useHistory } from 'react-router-dom'

import Row, { RowBetween } from '../../components/Row'
import Search from '../Restaurant/components/Search'
import Loading from '../../components/Loader/Loading'
import NoArtwork from '../../components/Collection/NoArtwork'
import InfiniteScroll from '../../components/view/InfiniteScroll'
import ArtworkCard from '../../components/Collection/ArtworkCard'
import SortPets from '../Pet/components/SortPets'
import { ButtonConfirmed } from '../../components/Button'
import Switch from '../../components/Switch'

import useYam from '../../hooks/bakery/useYam'
import { useActiveWeb3React } from '../../hooks'
import { CollectionArr } from '../../constants/nft'
import { userMarketType } from '../../userType/userMarketType'
import { userNftAddressNoAccount } from '../../userType/userNftAddress'
import { useReviewAddress } from '../../hooks/commonNft/useContract'
import { getArtworksV3, getArtworksV2, getArtworks } from '../../service/nft'
import { getWeapons, getWeaponsV2, getWeaponsV3 } from '../../service/weapon'
import { getPetEggs, getPetEggsV2, getPetEggsV3 } from '../../service/pet'
import { getPets, getPetsV2, getPetsV3, getBakeryCombos, getBakeryCombosV2,getBakeryCombosV3, getCollection } from '../../service/nft'
import { MAXSCROLLNUM, AuctionBake, SortOptions, PetSortOption, WeaponSortOption, ComboSortOption, TabOptions } from '../../constants/artwork'

const Wapper = styled.div`
  margin-top: -70px;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    text-align: center;
  `}
`
const CollectionWrapper = styled.div`
  max-width: 1184px;
  margin: 0 auto;
  position: relative;
  padding-left: 25px;
  padding-right: 25px;
`
const Banner = styled.div`
  width: 100%;
  img {
    width: 100%;
    height: auto;
    max-height: 320px;
  }
`
const Avatar = styled.div<{bg: string}>`
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  margin-top: -100px;
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100px;
    height: 100px;
    margin: 0 auto;
  `}
`
const Title = styled(RowBetween)`
  font-size: 40px;
  padding-top: 24px;
  padding-bottom: 8px;
  color: ${({ theme }) => theme.bsText22};
  font-family: 'Roboto-Bold';
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    justify-content: center;
  `}
` 
const DataRowBetween = styled(RowBetween)`
  margin-top: 20px;
  margin-bottom: 16px;
  flex-wrap: wrap;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
`
const FilterRow = styled.div`
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding-top: 30px;
  `}
`
const DataRow = styled.div`
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
`
const DataItem = styled.div`
  text-align: center;
  position: relative;
`
const CreatedRow = styled.div`
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    // justify-content: center;
  `}
`
const IconLine = styled.div<{margin?: string}>`
  display: inline-block;
  width: 1px;
  height: 30px;
  margin: ${({ margin }) => margin ? margin : '0 44px' };
  background: rgba(177, 177, 177, 0.41);
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 20px;
  `}
`
const LevelRow = styled(Row)`
  flex-direction: row-reverse;
  position: absolute;
  top: 145px;
  right: 0;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    position: static;
    justify-content: center;
    padding-top: 50px;
  `}
`
const activeLevel = 'ACTIVELEVEL'
const LevelText = styled(Text).attrs({activeLevel})`
  position: relative;
  width: 92px;
  font-family: 'Roboto-Bold';
  font-size: 22px;
  text-align: center;
  border-right: 1px solid rgba(177, 177, 177, 0.41);
  cursor: pointer;
  &.${activeLevel} {
    background: linear-gradient(to right, #FFD600, #FF7A00);
    -webkit-background-clip: text;
    color: transparent;
  }
  &:first-child {
    border: none;
  }
  img{
    position: absolute;
    right: 0;
    top: -15px;
  }
`
const MyArtworkBtn = styled.button`
  width: 148px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(to right, #FFD600, #FF7A00);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 14px;
  border-radius: 50px;
  border: 1px solid #FF7A00;
  font-family: 'Roboto-Bold';
  cursor: pointer;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin: 15px 0;
  `}
`
const CreatedBtn = styled(ButtonConfirmed)`
  color: ${({theme}) => theme.white};
  font-family: 'Roboto-Bold';
  padding: 0;
  border: none;
  font-size: 14px;
  width: 148px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  align-self: flex-start;
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  border-radius: 35px;
  margin-right: 8px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-self: center; 
  `}
`
const ArtworkList = styled.div`
  display: grid;
  grid-row-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 272px);
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`

export default function Collection(
  {
    match: {params: {nftType}}
  } : RouteComponentProps<{ nftType: string}>
) {
  const sushi = useYam()
  const { chainId, account } = useActiveWeb3React()
  const theme = useContext(ThemeContext)
  const history = useHistory()

  const level = ['v1', 'v2', 'v3']
  const [avtiveLevel, setActiveLevel] = useState(level[2])
  useEffect(() => {
    setActiveLevel(level[2])
  }, [nftType])

  const emptyArtworks: any[] = []
  const [artworkList, setArtworkList] = useState(emptyArtworks)
  const [loading, setLoading] = useState(false)
  const [loadedAll, setLoadedAll] = useState(false)
  const reviewAddress: any = useReviewAddress()
  const [canReview, setCanReview] = useState(false)
  const [reviewedId, setReviewedId] = useState<string[]>([])
  const [review, setReview] = useState(false)
  const [info, setInfo] = useState({
    holders: 0,
    totalSupply: 0,
    volumeTraded: 0,
    floorPrice: 0
  })

  const collectionInfo = useMemo(() => {
    const [item] = CollectionArr.filter((d: any) => d.urlName === nftType)
    return item
  }, [nftType])

  const nftTypes = useMemo(() => {
    const [item] = CollectionArr.filter((d: any) => d.urlName === nftType)
    return item.nftType
  }, [nftType])

  
  const getData = useMemo(() => {
    let methods
      switch (avtiveLevel) {
        case level[0]:
          switch (nftTypes) {
            case 'weapon':
              methods = getWeapons
              break;
            case 'pet':
              methods = getPets
              break
            case 'petEgg':
              methods = getPetEggs
              break
            case 'combo':
              methods = getBakeryCombos
              break
            default:
              methods = getArtworks
              break;
          }
          break;
        case level[1]:
          switch (nftTypes) {
            case 'weapon':
              methods = getWeaponsV2
              break;
            case 'pet':
              methods = getPetsV2
              break
            case 'petEgg':
              methods = getPetEggsV2
              break
            case 'combo':
              methods = getBakeryCombosV2
              break
            default:
              methods = getArtworksV2
              break;
          }
          break;
        case level[2]:
          switch (nftTypes) {
            case 'weapon':
              methods = getWeaponsV3
              break;
            case 'pet':
              methods = getPetsV3
              break
            case 'petEgg':
              methods = getPetEggsV3
              break
            case 'combo':
              methods = getBakeryCombosV3
              break
            default:
              methods = getArtworksV3
              break;
          }
          break;
        default:
          switch (nftTypes) {
            case 'weapon':
              methods = getWeaponsV3
              break;
            case 'pet':
              methods = getPetsV3
              break
            case 'petEgg':
              methods = getPetEggsV3
              break
            case 'combo':
              methods = getBakeryCombosV3
              break
            default:
              methods = getArtworksV3
              break;
          }
          break;
      }
    return methods
  }, [avtiveLevel, level, nftTypes])

  const filterSortOption = useMemo(() => {
    if (['pet', 'petEgg'].includes(nftTypes)) {
      return PetSortOption
    } else if (['weapon'].includes(nftTypes)) {
      return WeaponSortOption
    } else if (['combo'].includes(nftTypes)) {
      return ComboSortOption
    } else {
      return SortOptions.filter((d) => d.name !== 'Power')
    }
  }, [SortOptions, nftTypes])

  useEffect(() => {
    setCurSelect(filterSortOption[0])
  }, [filterSortOption])

  const [curSelect, setCurSelect] = useState(filterSortOption[0])
  const [curTab, setCurTab] = useState(TabOptions[0])
  const [curValue, setCurValue] = useState('')
  const [searchValue, setSearchValue] = useState('')

  const inputChange = useCallback((e: any) => {
    setCurValue(e.target.value)
  }, [])

  const updateData = useCallback((d) => {
    setCurSelect(d)
  }, [])

  const upTab = useCallback((d) => {
    setCurTab(d)
  }, [])

  const searchHandle = (value: string) => {
    setSearchValue(value)
  }

  const params = useMemo(() => {
    return {
      nftTypes: nftTypes,
      limit: 20,
      offset: 0,
      sortBy: curSelect.sortBy,
      sortName: curSelect.sortName,
      fileType: +curTab.sortName ? +curTab.sortName : '',
      keyword: searchValue.trim(),
      onSale: review ? undefined : 1,
      status: review ? 0 : 1,
    }
  }, [nftTypes, searchValue, curSelect, curTab, review, filterSortOption])

  const fetchList = async (update?: boolean) => {
    getData(chainId as number, {
      ...params,
      offset: artworkList.length,
    }, (err: any, data: any) => {
      setLoading(false)
      if (err) return
      if (data.code !== 0) return
      const dataAry = data.data.list || []
      const artworks = dataAry.map((d: any) => {
        return {
          ...d,
          tokenId: d.nftId || d.id,
          nftLevel: avtiveLevel,
          nftType: d.nftType || nftTypes,
          status: d.status !== undefined ? d.status : 1,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })

      let newList = []
      if (update) {
        newList = [...artworks]
      } else {
        newList = [...artworkList, ...artworks]
      }


      setArtworkList(newList)
      // setCount(data.data.count)
      if (newList.length >= data.data.count || newList.length > MAXSCROLLNUM) {
        setLoadedAll(true)
      }
    })
  }
  const loadmore = useCallback(() => {
    setLoading(true)
  }, [])

  const goMyArtwork = useCallback(() => {
    history.push(`/myArtwork/${nftType}`)
  }, [nftType])

  const goMint = useCallback(() => {
    history.push(`/mint-newArtworks/${nftTypes}`)
  }, [nftTypes])

  const getCollectionInfo = useCallback(() => {
    const nftAddress = collectionInfo.nftType.split(',').map((d) => {
      return userMarketType(d, 'v3')
    }).map((d) => {
      const address = account ? userNftAddressNoAccount(d)[chainId as number] : userNftAddressNoAccount(d)[56]
      return address
    }).join(',')
    getCollection(chainId as number, {
      address: nftAddress
    }, (err: any, data: any) => {
      if (err) return
      if (data.code !== 0) return
      const res = data.data
      const info = {
        holders: 0,
        totalSupply: 0,
        volumeTraded: 0,
        floorPrice: 0
      }
      res.forEach((d: any) => {
        info.holders += (+d.holders)
        info.totalSupply += (+d.totalSupply)
        info.volumeTraded += (+d.volumeTraded)
        info.floorPrice += (+d.floorPrice)
      })
      setInfo(info)
    })
  }, [collectionInfo, chainId, sushi, account])

  const toggleChecked = useCallback((id) => {
    setReview(!review)
  }, [review])

  const onUpdateReviewedId = useCallback(
    (id) => {
      const list = [...reviewedId, id]
      setReviewedId(list)
      setArtworkList(artworkList.filter((d) => !list.includes(d.id)))
    },
    [reviewedId, artworkList]
  )

  // 审核账号
  useEffect(() => {
    if (account && reviewAddress) {
      setCanReview(reviewAddress.includes(account))
    }
  }, [account, chainId, reviewAddress])

  // Init List
  useEffect(() => {
    setLoadedAll(false)
    setLoading(true)
    setArtworkList([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, chainId, avtiveLevel, review])

  useEffect(() => {
    getCollectionInfo()
  }, [getCollectionInfo])

  useEffect(() => {
    if (!loading) return
    fetchList()
  }, [getData, loading])

  return (
    <>
      <Loading open={loading} />
      <Wapper>
        <Banner>
          <img src={'/images/collection/' + collectionInfo.infoImg + '-bg.jpg'} alt=""/>
        </Banner>
        <CollectionWrapper>
          <Avatar bg={'/images/collection/' + collectionInfo.infoImg + '-avatar.png'}></Avatar>
          <LevelRow>
            {
              level.map((d, i) => {
                return (
                  <LevelText key={i} className={avtiveLevel === d ? activeLevel : ''} onClick={() => setActiveLevel(d)}>
                    {d === 'v3' && <img src="/images/collection/icon_new.svg" alt=""/>}
                    {d.toLocaleUpperCase()}
                  </LevelText>
                )
              })
            }
          </LevelRow>
          <Title>
            <Text>{collectionInfo.nick}</Text>
            <CreatedRow>
              {
                collectionInfo.mint ? <CreatedBtn onClick={goMint}>Create</CreatedBtn> : null
              }
              <MyArtworkBtn onClick={goMyArtwork}>My Artworks</MyArtworkBtn>
            </CreatedRow>
          </Title>
          <DataRowBetween>
            <DataRow>
              <DataItem>
                <Text color={theme.bsText22}fontSize={22} fontFamily={'Roboto-Bold'}>{new BigNumber(info.totalSupply).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)}</Text>
                <Text color={theme.bsText22}>items</Text>
              </DataItem>
              <IconLine />
              {/* <DataItem>
                <Text color={theme.bsText22} fontSize={22} fontFamily={'Roboto-Bold'}>{info.holders}</Text>
                <Text color={theme.bsText22}>owners</Text>
              </DataItem> */}
              {/* <IconLine /> */}
              <DataItem>
                <Text fontSize={22} fontFamily={'Roboto-Bold'}>{new BigNumber(info.volumeTraded).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)} USDT</Text>
                <Text>volume traded</Text>
              </DataItem>
            </DataRow>
            <FilterRow>
              <Search value={curValue} inputChange={inputChange} searchHandle={searchHandle}></Search>
              <SortPets
                bg={theme.bsBg30}
                height={32}
                margin="0 15"
                curSelect={curTab}
                options={TabOptions}
                updateData={upTab}
              ></SortPets>
              <SortPets
                wd='110px'
                height={32}
                bg={theme.bsBg30}
                curSelect={curSelect}
                options={filterSortOption}
                updateData={updateData}
              ></SortPets>
            </FilterRow>
          </DataRowBetween>
          {/* <Row flexDirection='row-reverse' marginTop={'16px'} marginBottom={'15px'}>
            <Text fontSize={16} color={theme.bsBg11} fontFamily={'Roboto-Bold'}>items</Text>
            <Text fontSize={16} color={theme.bsText22} fontFamily={'Roboto-Bold'} marginRight={'6px'}>{ new BigNumber(count).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT) }</Text>
          </Row> */}
          {
            canReview && collectionInfo.mint &&
            <Row justifyContent='flex-end' marginTop={'24px'} marginBottom={'16px'}>
              <Switch id={'review'} checked={review} toggleChecked={toggleChecked}></Switch>
            </Row>
          }
            {
              artworkList.length ?
                <InfiniteScroll loading={loading} loadedAll={loadedAll} loadmore={loadmore}>
                  <ArtworkList>
                    {
                      artworkList.map((d) => {
                        return (
                          <ArtworkCard key={d.id} artwork={d} status={review} onUpdateReviewedId={onUpdateReviewedId}></ArtworkCard>
                        )
                      })
                    }
                  </ArtworkList>
                </InfiniteScroll>
              : !loading && <NoArtwork></NoArtwork>
            }
        </CollectionWrapper>
      </Wapper>
    </>
  )
}
